import { array, boolean, object, string } from "yup";

const optionalUrl = (message: string) =>
  string()
    .url(message)
    .nullable()
    .transform((value: string) => (value === "" ? null : value));

// One schema for creating, editing and importing a zone; only creating picks countries (the form
// checks those itself, since the networks have to be read from OCS first).
const EsimZoneSchema = object().shape({
  nameSq: string().trim().required("Vendos emrin në shqip").max(200, "Emri ka të shumtën 200 shkronja"),
  nameEn: string().trim().required("Vendos emrin në anglisht").max(200, "Emri ka të shumtën 200 shkronja"),
  countries: array(),
  isRegional: boolean(),
  highRisk: boolean(),
  blockedForPurchase: boolean(),
  imageUrl: optionalUrl("URL e fotos nuk është e vlefshme"),
  coverImageUrl: optionalUrl("URL e kopertinës nuk është e vlefshme")
});

export default EsimZoneSchema;
